import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
import { inject, onMounted, reactive, ref } from "vue";
import { AdminServiceSymbol, LedgerServiceSymbol } from "@/InjectionSymbols";
import { validationRules } from "@/ValidationRules";
import { useMessageStore } from "@/stores/MessageStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DataSettingsView',
    setup(__props) {
        let inProgress = ref(false);
        const ledgers = reactive([]);
        let selectedLedger = ref(null);
        let form = ref(null);
        const ledgerService = inject(LedgerServiceSymbol);
        const adminService = inject(AdminServiceSymbol);
        const messageStore = useMessageStore();
        onMounted(() => {
            ledgerService?.loadAllLedgers().then(ledgersResponse => {
                ledgers.length = 0;
                ledgers.push(...ledgersResponse);
            });
        });
        function deleteBookingData() {
            form.value.resetValidation();
            form.value.validate().then((result) => {
                if (result.valid) {
                    inProgress.value = true;
                    adminService.deleteLedgerOrders(selectedLedger.value.id)
                        .then(() => {
                        messageStore.addMessage("Daten wurden gelöscht.");
                    }).catch(() => {
                        messageStore.addError("Fehler beim Löschen der Daten");
                    }).finally(() => {
                        inProgress.value = false;
                    });
                }
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_form = _resolveComponent("v-form");
            return (_openBlock(), _createBlock(_component_v_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_form, {
                        ref_key: "form",
                        ref: form
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, {
                                fluid: true,
                                class: "d-flex flex-wrap ma-0 pa-0"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_container, { class: "text-h4 text-start v-col-12" }, {
                                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                                            _createTextVNode(" Daten ")
                                        ])),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_container, { class: "d-flex v-col-12" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_card, {
                                                class: "mr-4",
                                                "min-width": "400px",
                                                "max-width": "400px"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_container, { class: "pa-0" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_container, { class: "text-start font-weight-bold v-col-12" }, {
                                                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                                    _createTextVNode("Buchungsdaten löschen")
                                                                ])),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_v_select, {
                                                                class: "compact px-4 flex-grow-1",
                                                                density: "compact",
                                                                modelValue: _unref(selectedLedger),
                                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(selectedLedger) ? (selectedLedger).value = $event : selectedLedger = $event)),
                                                                items: ledgers,
                                                                "item-title": "ledgerName",
                                                                label: "Konto",
                                                                variant: "outlined",
                                                                rules: [_unref(validationRules).required],
                                                                "return-object": ""
                                                            }, null, 8, ["modelValue", "items", "rules"]),
                                                            _createVNode(_component_v_container, { class: "text-red text-wrap" }, {
                                                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                                    _createTextVNode("Durch diese Aktion werden sämtliche Buchungen auf dem angegebenen Konto gelöscht. Alle reservierten Ressourcen werden freigegeben. Alle Daten sind dauerhaft verloren und können nicht wiederhergestellt werden. ")
                                                                ])),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_v_btn, {
                                                                onClick: deleteBookingData,
                                                                class: "ml-4 mb-4",
                                                                color: "error"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    (!_unref(inProgress))
                                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Buchungsdaten löschen"))
                                                                        : _createCommentVNode("", true),
                                                                    (_unref(inProgress))
                                                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                                            key: 1,
                                                                            indeterminate: true
                                                                        }))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 512)
                ]),
                _: 1
            }));
        };
    }
});
